/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled, Theme } from '@material-ui/core';

import { HeaderMode } from './Header';
import { Col, Typography } from 'components/UI';
import { Breakpoints } from 'utils/enums';

const ColLogo = styled(Col)(({ theme }) => ({
  '& svg path': {
    transition: theme.transitions.create('fill', {
      easing: theme.transitions.easing.easeInOut,
    }),
  },

  minHeight: theme.spacing(15),
  position: 'relative',
  zIndex: 2,

  [theme.breakpoints.up(Breakpoints.Md)]: {
    minHeight: theme.spacing(18),
  },
}));

const DesktopColMenu = styled(Col)(({ theme }) => ({
  display: 'none',
  marginBottom: theme.spacing(5),

  [theme.breakpoints.up(Breakpoints.Md)]: {
    display: 'flex',
    transform: `translateX(${theme.typography.pxToRem(16.5)})`,
  },
}));

const DesktopNavigation = styled('nav')(({ theme }) => ({
  '& a': {
    '&:hover, &.menu-item__active': { opacity: 0.6 },

    color: 'inherit',
    display: 'inline-block',
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(9.75),
    textDecoration: 'none',
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  alignItems: 'flex-end',
  display: 'flex',
}));

const DesktopNavigationItem = styled(Typography)<Theme, { mode: HeaderMode }>(
  ({ theme, mode }) => ({
    color:
      mode === 'light'
        ? theme.palette.primary.main
        : theme.palette.common.white,
    fontWeight: 500,
  })
);

export { ColLogo, DesktopColMenu, DesktopNavigation, DesktopNavigationItem };
